import { getElasticClient, indexShop } from './index';
import { addDataElastic, updateDataElastic, getOverviewShopElastic } from './elasticCommon';

const elasticClient = getElasticClient();

const createShopIndex = function() {
  // don't create if already created
  return new Promise((resolve, reject) => {
    elasticClient.indices.exists(
      {
        index: indexShop
      },
      (error, exists) => {
        if (error) {
          console.error(`Error when create index:${indexShop}`);
        }
        if (exists) {
          console.log(`Index ${indexShop} already exists`);
          resolve(exists);
        } else {
          elasticClient.indices.create(
            {
              index: indexShop,
              body: {
                mappings: {
                  _doc: {
                    properties: {}
                  }
                }
              }
            },
            (error, result) => {
              console.log(result);
              if (!error) {
                resolve(result);
              } else {
                reject(error);
              }
            }
          );
        }
      }
    );
  });
};

/**
 * Add shop to elastic search
 * @param {*} shop
 * example order input
 * {
 *   sidechainAddress: '0x24c5CC6E09C71F791A19da5BB1e581BDD42c8d7B',
 *   name: 'M Shop',
 *   etheAddress: '0xc7b03736163079Db290bfE97038C1365FAF0Af88',
 *   image: '',
 *   zipcode: '2233131',
 *   prefecture: '青森県',
 *   address: '例）中央区本町１−１ 第一ビル１０１号室',
 *   phoneNumber: '0326520632'
 * }
 */
const elasticAddShop = async function(shop, token) {
  shop.id = shop.sidechainAddress;
  return await addDataElastic({
    index: indexShop,
    type: '_doc',
    data: shop,
    token: token
  });
};

/**
 * Update shop by sidechainAddress
 * @param {*} id
 * @param {*} dataUpdate
 */
const elasticUpdateShop = async function(sidechainAddress, dataUpdate, token) {
  return await updateDataElastic({
    index: indexShop,
    type: '_doc',
    id: sidechainAddress,
    dataUpdate,
    token: token
  });
};

/**
 * get shop info on elasticsearch
 * @param {*} sidechainAddress
 * example data return
 * {
 *   sidechainAddress: '0x24c5CC6E09C71F791A19da5BB1e581BDD42c8d7B',
 *   name: 'M Shop',
 *   etheAddress: '0xc7b03736163079Db290bfE97038C1365FAF0Af88',
 *   image: '',
 *   zipcode: '2233131',
 *   prefecture: '青森県',
 *   address: '例）中央区本町１−１ 第一ビル１０１号室',
 *   phoneNumber: '0326520632'
 * }
 */
const elasticGetShop = async function(sidechainAddress) {
  return await elasticClient.getSource({
    index: indexShop,
    type: '_doc',
    id: sidechainAddress
  });
};

/**
 * Get overview shop in elastic
 * @return data overview
 * Example data return:
 * {numOfProductPublic: 15, numOfProductUnpublic: 2, revenueToday: 1111111126482946.8, revenueCurrentMonth: 1111111126482947.6, revenueLastMonth: 0}
 */
const elasticShopOverview = async function() {
  return await getOverviewShopElastic();
};

export { createShopIndex, elasticAddShop, elasticUpdateShop, elasticGetShop, elasticShopOverview };
